import { render, staticRenderFns } from "./conclusion.vue?vue&type=template&id=824c5b1c&scoped=true"
import script from "./conclusion.vue?vue&type=script&lang=js"
export * from "./conclusion.vue?vue&type=script&lang=js"
import style0 from "./conclusion.vue?vue&type=style&index=0&id=824c5b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c5b1c",
  null
  
)

export default component.exports